import useBootstrapData from '@/hooks/useBootstrapData'
import useClientSideSignedInData from '@/hooks/useClientSideSignedInData'
import usePriceWatches from '@/hooks/usePriceWatches'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'
import useSeti from '@/hooks/useSeti'
import type { AbandonedSelection, SearchProductList } from '../types'
import { computePriceWatchAndRecentSearches } from '../utils'
import useAbandonedSelections from './useAbandonedSelections'

function useTripActivityData(
  productType: SearchProductList,
  abandonedSelectionData?: AbandonedSelection | null,
) {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn: serverSignedIn },
    customer: { emailAddress: serverEmailAddress },
  } = useBootstrapData()

  const { signedIn: clientSideSignedIn, email: clientSideEmail } = useClientSideSignedInData()
  const signedIn = serverSignedIn || clientSideSignedIn
  const emailAddress = serverEmailAddress || clientSideEmail || ''
  const isPriceWatchSeti =
    useSeti({ experimentCode: 'HP_PUWYLO_PRICEWATCH', shouldFireImpression: false }) === 'VARIANT'
  const abandonedSelectionFetched = useAbandonedSelections(
    clientGUID,
    appName,
    appVersion,
    signedIn,
    productType,
  )

  // when signed in, abandonedSelectionData is passed in as a prop from the parent
  // and we will get the data from useTripGroupings
  const abandonedSelection = abandonedSelectionFetched || abandonedSelectionData

  const recentSearchData = useRecentSearchCard(clientGUID, { appName, appVersion }, productType, signedIn)

  const priceWatches = usePriceWatches(emailAddress, appName, appVersion, isPriceWatchSeti)
  return {
    abandonedSelection,
    atMostFiveRecentSearchCards: isPriceWatchSeti
      ? computePriceWatchAndRecentSearches(priceWatches, recentSearchData).slice(0, 5)
      : recentSearchData.slice(0, 5),
  }
}

export default useTripActivityData
